import { apiService } from './ServiceApi';

export const parentService = apiService.injectEndpoints({
  endpoints: (builder) => {
    return {
      getProfile: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/view`,
            body: {
              submitterAssignId: pData?.asgnId,
              versionNumber: pData?.version,
              destinationSystem: pData?.srchDestSysCd,
            },
            params: {},
          };
        },
      }),
      getProfileBySubmitter: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/search/submitter`,
            params: {},
            body: pData,
          };
        },
      }),
      getProfileByVersion: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/search/version`,
            params: {},
            body: pData,
          };
        },
      }),
      setProfile: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/update`,
            params: {
              updateCriteria: 'MODIFY',
              asgnId: pData?.m_demographics?.asgnId,
              srchDestSysCd: pData?.m_demographics?.eligSysId,
              version: pData?.m_demographics?.versions?.[0]?.versionNo + 1 || 0,
            },
            body: pData,
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      updateProfile: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/modify`,
            params: {},
            body:JSON.stringify({...pData}),
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      getProfileSearch: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/search/name`,
            params: {},
            body: JSON.stringify({ submitterAssignId: pData.search }),
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      addProfile: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/add`,
            params: {},
            body: pData,
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      getProfileList: builder.query({
        query: () => {
          return {
            method: 'GET',
            url: `profileservice/profile/lov`,
            params: {},
            body: {},
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      deleteContact: builder.query({
        query: (cData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/contact/delete`,
            params: {},
            body: {
              submitterGroupId: cData?.submitterGroupId,
              contactId: cData?.contactId,
            },
          };
        },
      }),
      submitContact: builder.query({
        query: (cData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/contact/edit`,
            params: {},
            body: cData,
          };
        },
      }),
      submitMoveProfile: builder.query({
        query: (moveData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/move`,
            params: {},
            body: moveData,
          };
        },
      }),
      createContact: builder.query({
        query: (cData) => {
          return {
            method: 'POST',
            url: `profileservice/profile/contact/create`,
            params: {},
            body: cData,
          };
        },
      }),
    };
  },
});

export const {
  useLazyGetProfileQuery,
  useLazyGetProfileBySubmitterQuery,
  useLazySetProfileQuery,
  useLazyGetProfileSearchQuery,
  useLazyGetProfileListQuery,
  useLazyGetProfileByVersionQuery,
  useLazyDeleteContactQuery,
  useLazySubmitContactQuery,
  useLazyAddProfileQuery,
  useLazyUpdateProfileQuery,
  useLazyCreateContactQuery,
  useLazySubmitMoveProfileQuery,
} = parentService;
